export interface MailOrderPendingBannerProps {
  customerServicePhone: string;
}

export function MailOrderPendingBanner({ customerServicePhone }: MailOrderPendingBannerProps) {
  return (
    <div style={{ textAlign: 'center', padding: '48px 24px', maxWidth: 560, margin: '0 auto' }}>
      {/* Pending icon */}
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          backgroundColor: '#0d6efd',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 20,
        }}
        aria-hidden="true"
      >
        <span style={{ color: 'white', fontWeight: 'bold', fontSize: 36 }}>&#8987;</span>
      </div>

      <h3 className="mb-2" style={{ fontWeight: 700 }}>Home Delivery Enrollment Pending</h3>
      <p className="text-muted mb-4" style={{ fontSize: '1rem' }}>
        Your activation request has been received and is currently being processed.
      </p>

      <hr style={{ borderColor: '#dee2e6', marginBottom: 24 }} />

      {/* Activation status details */}
      <div
        style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: 8,
          padding: '20px 24px',
          textAlign: 'left',
          marginBottom: 28,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          <span style={{ fontSize: 22, lineHeight: 1 }}>&#8505;</span>
          <div>
            <p style={{ fontWeight: 600, marginBottom: 6 }}>Activation in Progress</p>
            <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
              Account activation can take up to two business days. You will be notified once
              enrollment is complete. You won&rsquo;t be able to process refills until activation
              is finished. For questions, call{' '}
              <strong>{customerServicePhone}</strong>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
